/**
 * 
 * @param {*} isBian 
 * @param {*} xAxis_data X轴
 * @param {*} line_datas 线条数据二维数组
 * @param {*} line_datas_colors 线条颜色数组
 * @param {*} line_datas_widths 线条宽度数组
 * @param {*} line_datas_shadows_colors 线条阴影数组
 * @param {*} scatter_datas 小圆点数据二维数组
 * @param {*} scatter_datas_colors 小圆点颜色数组
 * @param {*} markArea_ranges 区域面积二维数据
 * @param {*} markArea_ranges_colors 区域颜色数组
 * @returns 
 */

export default function getEchartsOptionLineE1(xAxis_data, line_datas, line_datas_colors, line_datas_widths, line_datas_shadows_colors, scatter_datas, scatter_datas_colors,  markArea_ranges, markArea_ranges_colors, maxY) {
	
	// 向上保留两位小数
	maxY = Math.ceil(maxY * 100) / 100

	/**
		红色、蓝色、黄色、灰色四种折线图
		红色、黄色、绿色三种小点颜色
		红色、绿色、蓝色、黄色四种区域面具柱子
	 */
	/**
		markArea_ranges: 多个区域面积
		markArea_ranges_colors: 多个区域面积的颜色
	 */


	// 需要的 xAxis
	let needXAxis = [];

	// 需要的 yAxis
	let needYAxis = [];

	// 需要的 series
	let needSeries = [];


	/**
	 * 动态创建 Line Series
	 */
	let isHaveAxis = false;
	if (line_datas && line_datas.length > 0) {
		for (let i = 0; i < line_datas.length; i++) {

			let item = line_datas[i];

			// 需要的 Line Series
			let needLineSeries = {
				z: 2,
				type: 'line',
				data: item,
				smooth: true,
				symbol: 'none',
				lineStyle: {
					color: line_datas_colors[i],
					width: line_datas_widths && line_datas_widths.length > 0 ? line_datas_widths[i] : 1
				},
				// areaStyle: {
				// 	color: 'yellow'
				// }
			}
			if (line_datas_shadows_colors && line_datas_shadows_colors.length > 0 && line_datas_shadows_colors[i] != null) {
				needLineSeries.areaStyle = {
					color: line_datas_shadows_colors[i]
				}
			}
			needSeries.push(needLineSeries);

			// 需要的 Line XAxis
			let needLineXAxis = {
				type: 'category',
				data: xAxis_data,
				axisTick: {
					show: false,
				},
				axisLabel: {
					textStyle: {
						color: "#A5A9BC", //坐标的字体颜色
						fontSize: 10
					},
					formatter: function (value, index) {
						if (value % 1 == 0 && value % 2 != 0) {
							return value;
						} else {
							return null
						}
					},
					interval:0,
					show: isHaveAxis ? false : true
				},
				axisLine: {
					lineStyle: {
						color: "rgba(144, 148, 166, 0.1)",
						type: "solid",
					},
				}
			};
			needXAxis.push(needLineXAxis);

			// 需要的 Line YAxis
			let needLinewYAxis = {
				type: 'value',
				axisTick: { // 坐标轴刻度相关设置。
					show: false
				},
				axisLine: { // 坐标轴轴线相关设置。
					show: false
				},
				axisLabel: { // 坐标轴刻度标签的相关设置。
					textStyle: {
						color: "#A5A9BC", //坐标的字体颜色
						fontSize: 10
					},
					formatter: function (val) {
						return Math.floor(val * 100) + '%';
					},
				},
				splitNumber: 2,
				max: maxY ? maxY / 1 : null,
				interval: 0.01,
				minInterval: 0.01
			};
			needYAxis.push(needLinewYAxis);
			isHaveAxis = true;
		}
	}


	/**
	 * 动态创建小圆点
	 */
	if (scatter_datas && scatter_datas.length > 0) {
		for (let i = 0; i < scatter_datas.length; i++) {
			let item = scatter_datas[i];
			if (item && item.length > 0 && item.length == 2) {
				// 需要的小圆点 Series
				let needScatterSeries = {
					z: 3,
					type: 'scatter',
					symbolSize: 8,
					itemStyle: {
						color: scatter_datas_colors[i],
						borderWidth: 1.5,
						borderColor: 'rgba(230, 245, 242, 1)'
					},
					data: [
						item,
					]
				};
				needSeries.push(needScatterSeries);

				// 需要的小圆点 XAxis
				let needScatterXAxis = {
					type: 'category',
					data: xAxis_data,
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					axisLine: {
						show: false
					}
				};
				needXAxis.push(needScatterXAxis);

				// 需要的小圆点 YAxis
				let needScatterYAxis = {
					type: 'value',
					axisTick: { // 坐标轴刻度相关设置。
						show: false
					},
					axisLine: { // 坐标轴轴线相关设置。
						show: false
					},
					axisLabel: { // 坐标轴刻度标签的相关设置。
						show: false
					},
				};
				needYAxis.push(needScatterYAxis);
			}
		}
	}
	

	/**
	 * 动态创建 MarkAreaSeries
	 */
	if (markArea_ranges && markArea_ranges.length > 0) {
		for (let i = 0; i < markArea_ranges.length; i++) {
			let item = markArea_ranges[i];
			if (item && item.length > 0 && item.length == 2) {
				// 需要的面积区域 Series
				let needMarkAreaSeries = {
					z: 1,
					type: 'scatter',
					data: [[]],
					markArea: {
						itemStyle: {
							color: markArea_ranges_colors[i]
						},
						data: [
							[
								{
									xAxis: item[0]
								},
								{
									xAxis: item[1]
								}
							]
						]
					}
				};
				needSeries.push(needMarkAreaSeries);

				// 需要的面积区域 XAxis
				let needMarkAreaXAxis = {
					type: 'category',
					data: xAxis_data,
					axisLine: {
						show: false
					},
					axisLabel: { // 坐标轴刻度标签的相关设置。
						show: false,
					},
					axisTick: {
						show: false,
					},
				};
				needXAxis.push(needMarkAreaXAxis);

				// 需要的面积区域 YAxis
				let needMarkAreaYAxis = {
					type: 'value',
					axisTick: { // 坐标轴刻度相关设置。
						show: false
					},
					axisLine: { // 坐标轴轴线相关设置。
						show: false
					},
					axisLabel: { // 坐标轴刻度标签的相关设置。
						show: false
					},
				};
				needYAxis.push(needMarkAreaYAxis);
			}
		}
	}


	/**
	 * option
	 */
	let option = {
		animation: false,
		grid: {
			x: 10,
			y: 5,
			x2: 10,
			y2: 10,
			containLabel: true
		},
		xAxis: needXAxis,
		yAxis: needYAxis,
		series: needSeries
	};
	return option;
}